import { render, staticRenderFns } from "./LinkPasteInput.vue?vue&type=template&id=a29b013c&scoped=true"
import script from "./LinkPasteInput.vue?vue&type=script&lang=js"
export * from "./LinkPasteInput.vue?vue&type=script&lang=js"
import style0 from "./LinkPasteInput.vue?vue&type=style&index=0&id=a29b013c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29b013c",
  null
  
)

export default component.exports